/* Brisa #33 — Plazas/comensales junto al tamaño en el selector de variante.
 *
 * Lee el blob JSON inyectado por brisa-size-capacity.liquid (mapa option-value-tamaño → {label})
 * y añade un <span.brisa-capacity> dentro de cada label-swatch cuyo valor tenga dato.
 * Match por input[data-option-value] (valor exacto de la opción), NO por textContent.
 *
 * Sin tocar vendor liquid. Patrón observer/idempotencia clonado de brisa-variant-media-filter.js,
 * con CENTINELA PROPIO (_brisaCapacityObserver) para no colisionar con el filtro de galería.
 * El theme hace innerHTML-swap del picker en variant:change → re-inyectamos tras cada swap.
 */
(function () {
  "use strict";

  function getMap() {
    var el = document.getElementById("brisa-size-capacity");
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || "{}");
    } catch (e) {
      return null;
    }
  }

  function processPicker(map, root) {
    var inputs = root.querySelectorAll("input[data-option-value]");
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      var value = input.getAttribute("data-option-value");
      if (!value || !Object.prototype.hasOwnProperty.call(map, value)) continue;
      var entry = map[value];
      var label = entry && entry.label;
      if (!label) continue;
      // label-swatch asociado al input por for=id
      var lab = input.id ? root.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(input.id) : input.id) + '"]') : null;
      if (!lab) continue;
      if (lab.querySelector(".brisa-capacity")) continue; // idempotencia (anti-loop)
      var span = document.createElement("span");
      span.className = "brisa-capacity";
      span.textContent = label;
      lab.insertBefore(span, lab.firstChild);
      lab.classList.add("brisa-has-capacity");
    }
  }

  function processAll(map) {
    var pickers = document.querySelectorAll("variant-picker");
    for (var i = 0; i < pickers.length; i++) processPicker(map, pickers[i]);
  }

  function installObserver(root, schedule) {
    if (!root || root._brisaCapacityObserver) return; // centinela propio
    var obs = new MutationObserver(schedule);
    obs.observe(root, { childList: true, subtree: true });
    root._brisaCapacityObserver = obs;
  }

  function init() {
    var map = getMap();
    if (!map || !Object.keys(map).length) return; // sin dato → no-op limpio

    var scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          scheduled = false;
          processAll(map);
        });
      });
    }

    processAll(map);

    // Observa la raíz estable (la sección), no el picker (que se reemplaza en variant:change).
    var sections = document.querySelectorAll(".shopify-section");
    for (var i = 0; i < sections.length; i++) installObserver(sections[i], schedule);
    document.addEventListener("variant:change", schedule);
    document.addEventListener("change", function (e) {
      if (e.target && e.target.closest && e.target.closest("variant-picker")) schedule();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
